export const PERMISSIONS = {
  CORE: {
    VIEW_EVENT: 'core.view_event',
    VIEW_PAYMENT: 'core.view_payment',
    VIEW_OFFICE: 'core.view_office',
    VIEW_CONTACT: 'core.view_contact',
    ADD_CONTACT: 'core.add_contact',
    VIEW_AUDITLOG: 'core.view_auditlog',
    
    // Timesheet
    VIEW_TIMESHEET: 'core.view_timesheet',
    ADD_TIMESHEET: 'core.add_timesheet',
    CHANGE_TIMESHEET: 'core.change_timesheet',
    DELETE_TIMESHEET: 'core.delete_timesheet',

    // Faturamento (Billable Items)
    VIEW_BILLABLEITEM: 'core.view_billableitem',
    CHANGE_BILLABLEITEM: 'core.change_billableitem',

    // Faturas (Invoices)
    VIEW_INVOICE: 'core.view_invoice',
    ADD_INVOICE: 'core.add_invoice',
  },
  LAWSUIT: {
    VIEW_LAWSUIT: 'lawsuit.view_lawsuit',
  }
} as const;

export type AppPermission = 
  | typeof PERMISSIONS.CORE[keyof typeof PERMISSIONS.CORE]
  | typeof PERMISSIONS.LAWSUIT[keyof typeof PERMISSIONS.LAWSUIT];
